<app-dialog-wrapper
    heading="request.requestDetail.putRequestOnHoldDialog.title"
    description="request.requestDetail.putRequestOnHoldDialog.description"
    confirmLabel="request.requestDetail.putRequestOnHoldDialog.confirm"
    cancelLabel="request.requestDetail.putRequestOnHoldDialog.cancel"
    width="650px"
    [confirmDisabled]="formGroup.invalid"
    (confirmed)="confirm()"
    (cancelled)="close()"
>
    <form [formGroup]="formGroup" class="w-full">
        <sh-editor
            formControlName="comment"
            [placeholder]="'request.requestDetail.putRequestOnHoldDialog.comment' | translate"
            class="w-full"
        ></sh-editor>
    </form>
</app-dialog-wrapper>
